import ZskkDbController from '@/plug/indexeddb'
const tableName = 'logs'
const add = (response) => {
    const writeObject = formatResponse(response)
    if(writeObject) {
        // const print = console[writeObject['level'] || 'info']
        // if(typeof(print) === 'function') {
        //     print(writeObject)
        // }
        ZskkDbController.add(tableName, writeObject)
    }
}

const formatResponse = response => {
    if(typeof(response) !== 'object' || response === null) {
        console.warn('response is string or null :' + response)
        return null
    }
    const config     = formatRequest(response['config'])
    const res        = typeof(response['data']) === 'object' ? JSON.stringify(response['data']): response['data']
    const status     = response['status']
    const statusText = response['statusText']
    let level = 'info'
    if([200, 201, 202, 203, 204, 205, 301, 302, 304].indexOf(status) === -1) {
        level = 'error'
    } else if(!response['data'] || response['data']['code'] != 0) {
        level = 'warn'
    }
    const timestamp  = getTimestamp()
    const day        = getDay()
    return {...config, response: res, status, statusText, timestamp, day, level}
}

const getTimestamp = _ => new Date().getTime()
const getDay = _ => {
    const date = new Date()
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDay()
    return year + nubmer2String(month, 2) + nubmer2String(day, 2) 
}
const nubmer2String = (num, length) => {
    let str = num + ''
    while(str.length < length) {
        str = '0' + str
    }
    return str
}
const formatRequest = config => {
    if(!config || typeof(config) !== 'object') {
        console.warn('config is string or null :' + config)
        return {}
    }
    const request    = config['data']
    const url        = config['url']
    const method     = config['method']
    const headers    = config['headers']
    let temp_headers = {}
    if(headers) {
        const random     = headers['zskk-random']
        const signature  = headers['zskk-signature']
        const timestamp  = headers['zskk-timestamp']
        const token      = headers['ZSKK-TOKEN']
        temp_headers = {random, signature, request_timestamp: timestamp, token}
    }
    return {
        url, request, method, ...temp_headers
    }
}

const clear = (response) => {
    ZskkDbController.clear(tableName)
}

const getAll = (cb) => {
    ZskkDbController.queryAll(tableName,cb)
}

const ZskkLogController = {
    add, clear, getAll
}
export default ZskkLogController